import React from "react";
import moment from "moment";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { connect } from "react-redux";
import styled, { keyframes } from "styled-components";

import Card from "../core/Card";
import { GearIcon } from "../core/icons";

import "./Transactions.css";

const BankFetchingInfoDiv = styled.div`
  ${"" /* // used to animate in the bank txns gearIcons card */} &.slide-up, .slide-down {
    overflow: hidden;
  }
  &.slide-up {
    height: 0px;
    opacity: 0;
    transition: 0.4s ease-in-out;
  }
  &.slide-down {
    overflow: visible;
    opacity: 1;
    transition: 0.4s ease-in-out;
    height: 215px;
  }

  @keyframes spin-back {
    100% {
      transform: rotate(-360deg);
    }
  }

  sub {
    font-size: 16px;
  }
  .Card {
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .Gears {
    height: 60px;
    width: 70px;

    position: relative;
    .spin > svg {
      position: absolute;

      animation: spin 4s linear infinite;
      top: 20px;
    }

    .spin-back > svg {
      position: absolute;
      left: 30px;
      animation: spin-back 4s linear infinite;
    }
  }
`;

export default connect(({ transactions: { isFetchingFromBank } }) => {
  return {
    isFetchingFromBank
  };
})(({ isFetchingFromBank }) => (
  <BankFetchingInfoDiv
    className={
      "BankFetchingInfo " + (isFetchingFromBank ? "slide-down" : "slide-up")
    }
  >
    <Card>
      <div className="Gears">
        <div className="spin">
          <GearIcon width="40" height="40" />
        </div>
        <div className="spin-back">
          <GearIcon width="40" height="40" />
        </div>
      </div>
      <h3>Importing bank transactions...</h3>
      <sub>This might take a moment</sub>
    </Card>
  </BankFetchingInfoDiv>
));



// WEBPACK FOOTER //
// ./src/transactions/BankFetchingInfo.js